import {H3Text, H4Text} from '@buncha/components/core/text';
import {MainScreens, TabScreens} from '@buncha/navigation/types';
import React, {useCallback} from 'react';
import {useAppDispatch, useAppSelector} from '@buncha/config/redux/hooks';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {CustomDialogBox} from '@buncha/components/composites/dialogBox';
import If from '@buncha/components/conditional/If';
import {Modules} from '@buncha/utils/types';
import {PButton} from '@buncha/components/core/Button';
import {StyleSheet} from 'react-native';
import {navigation} from '@buncha/config/navigation';
import {onBoardingActions} from '@buncha/onBoarding/reducer';
import {useGetLocale} from '@buncha/localization/hooks';

const UnreadMemoModal = () => {
  const mortise = useFontTheme('mortise');
  const muli = useFontTheme('muli');
  const theme = useColorThemeType();
  const dispatch = useAppDispatch();
  const {title, body, button} =
    useGetLocale(Modules.home, MainScreens.Home) ?? {};

  const unreadMemoModal = useAppSelector(
    gState => gState.onboarding.unreadMemoModal,
  );

  const closeModal = useCallback(() => {
    dispatch(onBoardingActions.setUnreadMemoModal(false));
  }, [dispatch]);

  const navigateToMemos = useCallback(() => {
    closeModal();
    navigation.navigate(MainScreens.Tabs, {
      screen: TabScreens.Memos,
    });
  }, [closeModal]);

  return (
    <If condition={unreadMemoModal}>
      <CustomDialogBox
        modalBoxStyle={styles.modalBoxStyle}
        onClose={closeModal}
        header={
          <H3Text
            style={[
              styles.marBot10,
              {
                fontFamily: mortise[700].normal,
                color: theme?.text.blue[300],
              },
            ]}>
            {title?.unreadMessages}
          </H3Text>
        }
        body={
          <H4Text style={[styles.marBot_10, {fontFamily: muli[700].normal}]}>
            {body?.unreadMessages}
          </H4Text>
        }
        footer={
          <PButton
            title={button?.openMemos}
            style={styles.actionButton}
            titleStyle={{
              fontFamily: muli[700].normal,
            }}
            onPress={navigateToMemos}
          />
        }
      />
    </If>
  );
};

export default React.memo(UnreadMemoModal);

export const styles = StyleSheet.create({
  actionButton: {
    borderRadius: 50,
    marginVertical: 10,
  },
  modalBoxStyle: {padding: 10, borderRadius: 20},
  marBot10: {
    marginBottom: 10,
  },
  marBot_10: {
    marginBottom: -10,
  },
});
